import { GroupEntityListModalComponent } from './group-entity-list-modal.component';

export const GroupEntityListModalModule = angular
  .module('sfMobile.components.group-entity-list-modal', [])
  .component('sfGroupEntityListModal', GroupEntityListModalComponent).name;
